/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { withRouter } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import ProviderTabs from './gridPanel/tabs';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { getContactDetails } from '../../../Maintain/group/store/group-action';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import * as message from '../../../Maintain/Plan/component/message';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import PlanContactForm from '../../../Maintain/Plan/component/planContactForm';
import ProviderOtherInfo from './providerOtherInfo';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { dispatchProviderTabData } from '../store/action';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  getAllContactType,
  getExistingContactDetails,
  resetContactData,
  saveContactData,
} from '../../../Maintain/Plan/store/actions';

import { getExistingCommentLinkIds } from '../../../../SharedModules/utilities/commonAPI';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

function Provider() {
  const dispatch = useDispatch();
  const payload = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerDetails
  );

  const allContactData = useSelector((state) => {
    return state.sharedState.PlanReducer.allContactData;
  });

  const updateOrSaveContactDetailsMessage = useSelector((state) => {
    return state.sharedState.PlanReducer.updateOrSaveContactDetailsMessage;
  });

  const providerIdTypeDropDown = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );

  const providerTabData = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerTabData
  );

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const childRef = useRef(null);

  const initialContactData = {
    clientId: '-1',
    clientName: null,
    groupId: '-1',
    groupName: null,
    planId: '',
    planName: null,
    rebateProgramCd: null,
    contactTypeCd: '-1',
  };

  const [providerData, setProviderData] = useState(payload);
  const [isFormChanged, setIsFormChanged] = useState(true);
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessage, setSuccessMessage] = useState([]);
  const [providerIdTypeDesc, setProviderIdTypeDesc] = useState('');
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [tabValue, setTabValue] = useState('one');
  const [showComments, setShowComments] = useState(false);
  const [mailOrder, setMailOrder] = useState(false);
  const [contactErrors, setContactErrors] = useState([]);
  const [contactFormDirty, setContactFormDirty] = useState(false);
  const [contactData, setContactData] = useState({
    ...initialContactData,
    ...payload,
    ...allContactData,
  });
  const [disableFields, setDisableFields] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [savePopup, setSavePopup] = useState(false);
  const [ccCommentsExist, setCcCommentsExist] = useState(0);
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const history = useHistory();
  /** Component first load */
  useEffect(() => {
    setTabValue(providerTabData?.tabValue ?? 'one');
    setErrorMessages(providerTabData?.errorMessages ?? []);
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  useEffect(() => {
    getExistingComments();
  }, [showComments]);

  const getExistingComments = async () => {
    const res = await getExistingCommentLinkIds([providerData?.corrLinkId]);
    setCcCommentsExist(res?.includes(providerData?.corrLinkId) ? 1 : 0);
  };

  useEffect(() => {
    setContactData({
      ...contactData,
      ...allContactData,
    });
  }, [tabValue]);

  /** Dispatch dispatchProviderTabData action */
  const setProviderTabData = (data) => {
    dispatch(dispatchProviderTabData(data));
  };

  /** Set tabValue and providerTabData */
  const handleSetTabValue = (newValue) => {
    setTabValue(newValue);
    setProviderTabData({
      ...providerTabData,
      tabValue: newValue,
    });
  };

  /** Set errorMessages and providerTabData */
  const handleSetSuccessMessage = (messages) => {
    setErrorMessages(messages);
    setProviderTabData({
      ...providerTabData,
      errorMessages: messages,
    });
  };

  useEffect(() => {
    if (updateOrSaveContactDetailsMessage === 'Success') {
      setSuccessMessage([message.SUCESS_MESSAGE]);
    } else {
      setSuccessMessage([]);
    }
  }, [updateOrSaveContactDetailsMessage]);

  /** Update tabItemsData(localStorage) in isFormChanged and errorMessages dependencies */
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (
          item.navTo === '/providerDetails' &&
          (!isFormChanged || contactFormDirty)
        ) {
          item.isFormDirty = true;
          if (errorMessages && errorMessages.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/providerDetails') item.isFormDirty = false;
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [isFormChanged, contactFormDirty, errorMessages]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData')) ?? [];
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/providerDetails' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/providerDetails' && item.isFormSave) {
          item.isFormSave = false;
          setIsFormChanged(false);
          saveFromCloseTab();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
    if (
      updateTabs?.find((x) => x.navTo === '/providerDetails')?.from === 'claim'
    ) {
      setDisableFields(true);
    } else {
      setDisableFields(false);
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const saveFromCloseTab = async () => {
    await onSave();
    dispatch(saveContactData({}));
    closeTab('/providerDetails', history, dispatch);
  };

  const [prvContactValues, setPrvContactValues] = useState({
    addrLine1: '',
    addrLine2: '',
    addrLine3: '',
    city: '',
    contactName: '',
    contactSeqNum: '',
    contactTypeCd: '',
    corpName: '',
    faxNum: '',
    key: '',
    keyTypeCd: '',
    phoneExtension: '',
    phoneNum: '',
    stateCd: '',
    zip: '',
    zip4: '',
  });

  const [applyFilter, setApplyFilter] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const dateChange = (date) => {
    const data = date.split('-');
    const d = data[2].split('T');
    const x = `${d[0]}/${data[1]}/${data[0]}`;
    return x;
  };

  useEffect(() => {
    setSuccessMessage([]);
    if (payload?.providerPK) {
      setProviderData(payload);
    }
    const providerIdTypeCdDetail =
      providerIdTypeDropDown?.length > 0 &&
      providerIdTypeDropDown.find(
        (element) =>
          element.codeValueID.codeValue ===
          providerData?.providerPK?.providerIdTypeCd
      );
    setProviderIdTypeDesc(providerIdTypeCdDetail?.shortDescription);
  }, [payload]);

  /** Reset Contact Data if we select another provider record */
  useEffect(() => {
    setContactData({
      ...initialContactData,
      ...payload,
    });
  }, [providerData?.providerPK?.providerId]);

  useEffect(() => {
    dispatch(getAllContactType({ keyTypeCd: 'TYPEPROV' }, 'provider'));
    if (providerData?.providerPK?.providerId) {
      dispatch(
        getExistingContactDetails(
          {
            key: [
              `${providerData?.providerPK?.providerIdTypeCd}-${providerData?.providerPK?.providerId}`,
            ],
            keyTypeCd: 'TYPEPROV',
          },
          'provider'
        )
      );
    }
  }, []);

  const isValidContactForm = () => {
    const errorMessageArray = [];
    let ContactErr = false;

    if (contactFormDirty && contactErrors && contactErrors.length > 0) {
      ContactErr = true;
    }

    if (errorMessageArray.length > 0 || ContactErr) {
      const allErrors = ContactErr
        ? contactErrors.concat(errorMessageArray)
        : errorMessageArray;
      handleSetSuccessMessage(allErrors);
      return false;
    }
    return true;
  };

  const addUpdateContact = (data) => {
    return axios
      .post(serviceEndPoint.UPDATE_CONTACT_DETAILS, [data])
      .then((response) => {
        setSuccessMessage([message.SUCESS_MESSAGE]);
        setIsFormChanged(true);
        setContactFormDirty(false);
        dispatch(getAllContactType({ keyTypeCd: 'TYPEPROV' }, 'provider'));
        dispatch(
          getExistingContactDetails(
            {
              key: [
                `${providerData?.providerPK?.providerIdTypeCd}-${providerData?.providerPK?.providerId}`,
              ],
              keyTypeCd: 'TYPEPROV',
            },
            'provider'
          )
        );
        dispatch(
          getContactDetails(
            {
              keyTypeCd: 'TYPEPROV',
              key: `${providerData?.providerPK?.providerIdTypeCd}-${providerData?.providerPK?.providerId}`,
              contactTypeCd: allContactData.contactTypeCd,
            },
            'provider'
          )
        );
        return response.data;
      })
      .catch(({ response }) => response.data);
  };

  const onSave = async () => {
    if (!contactFormDirty) {
      return;
    }
    if (isValidContactForm()) {
      setSuccessMessage([]);
      handleSetSuccessMessage([]);
      const providerPK = {
        providerId: providerData.providerPK.providerId,
        providerIdTypeCd: providerData.providerPK.providerIdTypeCd,
      };
      const formattedPayload = {};
      let contactsData = {};
      if (allContactData?.phoneNum) {
        let newPhn =
          allContactData &&
          allContactData.phoneNum &&
          allContactData.phoneNum.replace(/-| |/g, '');
        newPhn = newPhn.replace('(', '');
        newPhn = newPhn.replace(')', '');
        contactsData = { ...allContactData, phoneNum: newPhn };
      }
      await addUpdateContact(contactsData);
      handleSetSuccessMessage([]);
    }
  };

  const onReset = () => {
    handleSetSuccessMessage([]);
    setMailOrder(false);
    setIsFormChanged(true);
    setContactFormDirty(false);
    setContactErrors([]);
    dispatch(resetContactData());
    setProviderData({ ...payload });
    setSuccessMessage([]);
  };

  const handleClearFilter = () => {
    if (applyFilter) {
      childRef.current && childRef.current.clearFilters();
      setSpinnerLoader(false);
      setApplyFilter(false);
    }
  };

  const getShowViewHistoryPlan = () => {
    setShowViewHistory(true);
    if (tabValue === 'three') {
      setKeyValue({
        CONTACT_SEQ_NUM: prvContactValues && prvContactValues.contactSeqNum,
      });
    } else {
      setKeyValue({
        CONTACT_SEQ_NUM: prvContactValues && prvContactValues.contactSeqNum,
      });
    }
  };

  return (
    <>
      <div className='tBillPanel custom-check'>
        <div className='panel tBillPanel-space pb-0'>
          <Spinner load={spinnerLoader} />
          <CustomSeparator parent1='Display' parent2='Provider Details' />
          <DisplaySuccessMessages successMessages={successMessage} />
          <DisplayErrorMessages errorMessages={errorMessages} />
          <SaveCancelPopup
            open={openCancel}
            title='Cancel'
            onConfim={() => {
              onReset();
              setOpenCancel(false);
            }}
            onCancel={() => {
              setOpenCancel(false);
              dispatch(saveContactData({}));
            }}
          />
          <SaveCancelPopup
            open={savePopup}
            title='Save'
            onClose={() => setSavePopup(false)}
            onConfim={async () => {
              await onSave();
              setSavePopup(false);
            }}
            onCancel={() => {
              setSavePopup(false);
            }}
          />
          <fieldset className='custom-fieldset'>
            <form autoComplete='off'>
              <div className='form-wrapper form-wrapper-col-4'>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='provider_id_type'
                    label='Provider ID Type'
                    tabIndex={0}
                    fullWidth
                    placeholder=''
                    value={providerIdTypeDesc || ''}
                    inputProps={{ readOnly: true }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  {providerData?.name?.length > 22 ? (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='com-tooltip'>
                          {providerData && providerData.name
                            ? providerData?.name
                            : null}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id='provider_name'
                        label='Provider Name'
                        fullWidth
                        placeholder=''
                        tabIndex={0}
                        value={`${
                          providerData && providerData.name
                            ? providerData?.name.substring(0, 22)
                            : null
                        } ...`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id='provider_name'
                      label='Provider Name'
                      fullWidth
                      tabIndex={0}
                      placeholder=''
                      value={
                        providerData && providerData.name
                          ? providerData?.name
                          : null
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                    />
                  )}
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='provider_id'
                    label='Provider ID'
                    fullWidth
                    placeholder=''
                    tabIndex={0}
                    value={
                      providerData &&
                      providerData &&
                      providerData.providerPK &&
                      providerData.providerPK.providerId
                        ? providerData.providerPK.providerId
                        : null
                    }
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='review_complete_date'
                    label='Review Complete Date'
                    fullWidth
                    placeholder=''
                    tabIndex={0}
                    value={
                      providerData &&
                      providerData.provider &&
                      providerData.provider.auditCompleteDt
                        ? dateChange(providerData.provider.auditCompleteDt)
                        : null
                    }
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
              </div>
              <div className='form-wrapper form-wrapper-col-4'>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='nabp_number'
                    label='NABP Number'
                    tabIndex={0}
                    fullWidth
                    placeholder=''
                    value={
                      providerData && providerData.nabpNum
                        ? providerData.nabpNum
                        : null
                    }
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='provider_type'
                    label='Provider Type'
                    tabIndex={0}
                    fullWidth
                    placeholder=''
                    value={
                      providerData?.providerTypeCd
                        ? providerData.providerTypeCd
                        : null
                    }
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                {hasAccess && (
                  <div className='mui-custom-form input-md'>
                    <div className='comment-sec mt-26' tabIndex={0}>
                      Comments{' '}
                      {parseInt(ccCommentsExist, [0, 1]) === 1 ? (
                        <img
                          role='button'
                          onClick={() => {
                            setShowComments(true);
                          }}
                          alt=' comment '
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setShowComments(true);
                            }
                          }}
                          src={CommentVisibleIcon}
                        />
                      ) : (
                        <img
                          role='button'
                          onClick={() => {
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setShowComments(true);
                            }
                          }}
                          alt='comment'
                          src={CommentIcon}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </fieldset>
          <div className='btn-wrapper mb-2'>
            <div className='float-right mt-2 hide-on-print'>
              <Button
                className='btn btn-success btn-search'
                data-testid='saveBtn'
                disabled={(isFormChanged && !contactFormDirty) || !isEnablebyRole}
                onClick={() => setSavePopup(true)}
              >
                <SVGComponent iconName='Icon-awesome-save' />
                Save
              </Button>
              <Button
                onClick={() => setOpenCancel(true)}
                disabled={isFormChanged && !contactFormDirty}
                data-testid='cancelBtn'
                className='btn btn-cancel btn btn-primary'
              >
                <SVGComponent iconName='Icon-cancel' />
                Cancel
              </Button>
            </div>
            <div className='clearfix' />
          </div>
          <div className='tabs-wrapper'>
            <div className='float-left'>
              <ProviderTabs
                handleChangeTabValue={(event, newValue) => {
                  handleSetTabValue(newValue);
                  handleClearFilter();
                }}
                tabValue={tabValue}
                errorMessages={errorMessages}
              />
            </div>
            <div className='clearfix' />
          </div>
          <div className='tabs-body'>
            {tabValue === 'one' && (
              <>
                <div className='form-wrapper form-wrapper-col-4 pb-0 pl-3'>
                  <div className='mui-custom-form input-md'>
                    {providerData?.name?.length > 22 ? (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip id='com-tooltip'>
                            {providerData?.name}
                          </Tooltip>
                        }
                      >
                        <TextField
                          tabIndex={0}
                          id='providerName'
                          label='Provider Name'
                          fullWidth
                          placeholder=''
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={`${providerData?.name.substring(0, 22)} ...`}
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id='providerName'
                        label='Provider Name'
                        tabIndex={0}
                        fullWidth
                        placeholder=''
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={providerData?.name}
                      />
                    )}
                  </div>
                  <div className='mui-custom-form input-md'>
                    <TextField
                      id='providerPhoneNum'
                      label='Provider Phone Num'
                      fullWidth
                      tabIndex={0}
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={providerData?.phoneNum}
                    />
                  </div>
                  <div className='mui-custom-form input-md'>
                    <div className='comment-sec mt-26'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            checked={mailOrder}
                            name='mailOrder'
                            onChange={() => {
                              setMailOrder(!mailOrder);
                            }}
                          />
                        }
                        label='Mail Order'
                        disabled={disableFields}
                      />
                    </div>
                  </div>
                </div>
                <PlanContactForm
                  isProivder
                  setContactErrors={setContactErrors}
                  keyTypeCd='TYPEPROV'
                  entityType='TYPEPROV'
                  contactType='provider'
                  setErrorMessages={handleSetSuccessMessage}
                  disabledSaveCancelBtn={isFormChanged}
                  disableFields={disableFields}
                  defaultValues={contactData}
                  setContactValues={setPrvContactValues}
                  setIsFormChanged={setIsFormChanged}
                  onContactDirtyChange={setContactFormDirty}
                  contactFormDirty={contactFormDirty}
                  savePopup={savePopup}
                  onViewHistoryClick={getShowViewHistoryPlan}
                  setSuccessMessage={setSuccessMessage}
                  providerId={providerData?.providerPK?.providerId}
                  keyId={`${providerData?.providerPK?.providerIdTypeCd}-${providerData?.providerPK?.providerId}`}
                />
              </>
            )}
            {tabValue === 'two' && <ProviderOtherInfo />}
          </div>
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName={
            tabValue === 'one'
              ? 'CONTACT'
              : tabValue === 'two'
              ? 'OTHER_INFO'
              : 'CONTACT'
          }
          keyValue={keyValue}
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='PROVIDER'
          corrLinkId={providerData?.corrLinkId}
          rowGridPrimaryKey={
            providerData ? providerData?.providerPK?.providerId : 0
          }
        />
      ) : null}
    </>
  );
}
export default withRouter(Provider);
